import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { ADJUSTED_RESIDUAL_LABEL, DOLLAR_SIGN } from '../../../constants';
import { useHeldSelector } from '../../../hooks/useHeldSelector';

export const useAdjustedResidualDisplayValue = () => {
    const residualValue = useHeldSelector(offerReduxSelectors.getAdjustedResidualValue);

    return { label: ADJUSTED_RESIDUAL_LABEL, value: formatNumberAndCents(residualValue), prefix: DOLLAR_SIGN };
};
